import React from "react";
import { FaSpinner } from "react-icons/fa";

const Spinner = ({ className = "", size }) => (
  <FaSpinner
    className={`animate-spin ${className}`}
    size={size}
    aria-hidden="true"
  />
);

// Full-area loading state (route gates, page data).
export const PageSpinner = ({ label }) => (
  <div
    className="min-h-[50vh] flex flex-col items-center justify-center gap-3 text-white/80"
    role="status"
  >
    <Spinner size={32} />
    {label && <span className="text-sm">{label}</span>}
  </div>
);

export default Spinner;
